export default([
  {
    label   : 'Discharge Date',
    itemKey : 'dischargeDate',
    decoder : 'formatDate'
  },
  {
    label   : 'Mother Condition',
    itemKey : 'motherCondition',
    decoder : 'decodeMotherCondition'
  },
  {
    label   : 'Antecedent Type',
    itemKey : 'antecedentType',
    decoder : 'decodeAntecedentType'
  },
  /*
  // Removed because of June 2 Revisions
  {
    label   : 'Underlying Cause',
    itemKey : 'antecedentCause',
    decoder : 'decodeUnderlyingCause'
  },*/
  {
    label   : 'Timing of Death',
    itemKey : 'deathTiming',
    decoder : 'decodeSpecific'
  }
])
